import { createContext } from 'react'
import {
  contexts,
  componentLoader as components,
  packageLoader as packages,
  pageBlockRegistry as pageBlocks,
} from '../registry'
import { RegistryContextValue } from './types'

export const RegistryContext = createContext<RegistryContextValue>({
  contexts,
  components,
  packages,
  pageBlocks,
})

export const RegistryContextProvider = RegistryContext.Provider
